export const SET_WOLT_RESTAURANTS = 'SET_WOLT_RESTAURANTS'
export const SET_WOLT_RESTAURANTS_TOTAL_LENGTH = 'SET_WOLT_RESTAURANTS_TOTAL_LENGTH'
export const SET_WOLT_RESTAURANT = 'SET_WOLT_RESTAURANT'
export const APPEND_WOLT_RESTAURANTS = 'APPEND_WOLT_RESTAURANTS'
export const SET_WOLT_RESTAURANTS_SHOW_ERROR_MODAL = 'SET_WOLT_RESTAURANTS_SHOW_ERROR_MODAL'
export const SET_WOLT_RESTAURANT_INTEGRATION_LINK_IS_CREATING = 'SET_WOLT_RESTAURANT_INTEGRATION_LINK_IS_CREATING'
export const SET_WOLT_RESTAURANT_INTEGRATION_CODE = 'SET_WOLT_RESTAURANT_INTEGRATION_CODE'
export const SET_WOLT_RESTAURANT_SHOW_CREATE_INTEGRATION_MODAL = 'SET_WOLT_RESTAURANT_SHOW_CREATE_INTEGRATION_MODAL'
export const SET_SHOW_WOLT_RESTAURANT_DATA_MODAL = 'SET_SHOW_WOLT_RESTAURANT_DATA_MODAL'
export const SET_WOLT_RESTAURANT_SHOW_SUCCESS_INTEGRATION_MESSAGE = 'SET_WOLT_RESTAURANT_SHOW_SUCCESS_INTEGRATION_MESSAGE'
export const SET_WOLT_RESTAURANT_SHOW_ERROR_INTEGRATION_MESSAGE = 'SET_WOLT_RESTAURANT_SHOW_ERROR_INTEGRATION_MESSAGE'
